/**
 * @fileoverview gRPC-Web generated client stub for dash.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v0.0.0
// source: dash/v1/lesson.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var dash_v1_models_pb = require('../../dash/v1/models_pb.js')

var types_v1_status_pb = require('../../types/v1/status_pb.js')
const proto = {};
proto.dash = {};
proto.dash.v1 = require('./lesson_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dash.v1.LessonServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dash.v1.LessonServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dash.v1.GetLessonRequest,
 *   !proto.dash.v1.GetLessonResponse>}
 */
const methodDescriptor_LessonService_GetLesson = new grpc.web.MethodDescriptor(
  '/dash.v1.LessonService/GetLesson',
  grpc.web.MethodType.UNARY,
  proto.dash.v1.GetLessonRequest,
  proto.dash.v1.GetLessonResponse,
  /**
   * @param {!proto.dash.v1.GetLessonRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dash.v1.GetLessonResponse.deserializeBinary
);


/**
 * @param {!proto.dash.v1.GetLessonRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dash.v1.GetLessonResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dash.v1.GetLessonResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dash.v1.LessonServiceClient.prototype.getLesson =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dash.v1.LessonService/GetLesson',
      request,
      metadata || {},
      methodDescriptor_LessonService_GetLesson,
      callback);
};


/**
 * @param {!proto.dash.v1.GetLessonRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dash.v1.GetLessonResponse>}
 *     Promise that resolves to the response
 */
proto.dash.v1.LessonServicePromiseClient.prototype.getLesson =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dash.v1.LessonService/GetLesson',
      request,
      metadata || {},
      methodDescriptor_LessonService_GetLesson);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dash.v1.PutLessonRequest,
 *   !proto.dash.v1.PutLessonResponse>}
 */
const methodDescriptor_LessonService_PutLesson = new grpc.web.MethodDescriptor(
  '/dash.v1.LessonService/PutLesson',
  grpc.web.MethodType.UNARY,
  proto.dash.v1.PutLessonRequest,
  proto.dash.v1.PutLessonResponse,
  /**
   * @param {!proto.dash.v1.PutLessonRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dash.v1.PutLessonResponse.deserializeBinary
);


/**
 * @param {!proto.dash.v1.PutLessonRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dash.v1.PutLessonResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dash.v1.PutLessonResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dash.v1.LessonServiceClient.prototype.putLesson =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dash.v1.LessonService/PutLesson',
      request,
      metadata || {},
      methodDescriptor_LessonService_PutLesson,
      callback);
};


/**
 * @param {!proto.dash.v1.PutLessonRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dash.v1.PutLessonResponse>}
 *     Promise that resolves to the response
 */
proto.dash.v1.LessonServicePromiseClient.prototype.putLesson =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dash.v1.LessonService/PutLesson',
      request,
      metadata || {},
      methodDescriptor_LessonService_PutLesson);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dash.v1.ListLessonsRequest,
 *   !proto.dash.v1.ListLessonsResponse>}
 */
const methodDescriptor_LessonService_ListLessons = new grpc.web.MethodDescriptor(
  '/dash.v1.LessonService/ListLessons',
  grpc.web.MethodType.UNARY,
  proto.dash.v1.ListLessonsRequest,
  proto.dash.v1.ListLessonsResponse,
  /**
   * @param {!proto.dash.v1.ListLessonsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dash.v1.ListLessonsResponse.deserializeBinary
);


/**
 * @param {!proto.dash.v1.ListLessonsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dash.v1.ListLessonsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dash.v1.ListLessonsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dash.v1.LessonServiceClient.prototype.listLessons =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dash.v1.LessonService/ListLessons',
      request,
      metadata || {},
      methodDescriptor_LessonService_ListLessons,
      callback);
};


/**
 * @param {!proto.dash.v1.ListLessonsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dash.v1.ListLessonsResponse>}
 *     Promise that resolves to the response
 */
proto.dash.v1.LessonServicePromiseClient.prototype.listLessons =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dash.v1.LessonService/ListLessons',
      request,
      metadata || {},
      methodDescriptor_LessonService_ListLessons);
};


module.exports = proto.dash.v1;

